import { Injectable, Injector } from '@angular/core';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { LazyLoadEvent } from 'primeng/api';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map, catchError, tap } from 'rxjs/operators';
import * as FileSaver from 'file-saver';
import { DeductionHold } from '../entities/deduction-hold';
import { ParamsDeductionHold } from '../model/params-deduction-hold';
import { BaseCrudService } from 'app/shared/_utils/services/base-crud-service';

@Injectable()
export class DeductionHoldService extends BaseCrudService<DeductionHold> {

  public uri = '/api/deductionHold/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance DeductionHoldService');
  }

  buildSentence(entity?: DeductionHold, event?: LazyLoadEvent): HttpParams {
    return null;
  }

  exportAll4thCertificate ( object: any ): Observable<Blob> {
    // let ruta =  this.uri   +  "exportAll4thCertificate"; 
    const ruta = `${this.rutaServidor}${this.uri}exportAll4thCertificate`;
    let nameFile : "reportCertificate4th.pdf"; 
    this.spinnerService.showAll();
   // return this.http.get<PayStub[]>(`${this.url}/search`, {params})
    return this.httpClient.post(ruta,object, {responseType: 'blob' })
    .pipe( 
        map(res =>  { 
            this.spinnerService.hideAll();
            let bean = new Blob([res],{ type: 'application/pdf'});
            FileSaver.saveAs(bean, nameFile);
            return bean;
            }   ),
        catchError((err) => { 
            console.log("catchError : "  + catchError);
            this.spinnerService.hideAll();
            this.notificationService.serverErrorMessage(err.status +' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
            return new Observable<Blob>();
        })
            
        ) ;
    }

    exportAll5thCertificate ( object: any ): Observable<Blob> {
      // let ruta =  this.uri   +  "exportAll4thCertificate"; 
      const ruta = `${this.rutaServidor}${this.uri}exportAll5thCertificate`;
      let nameFile : "reportCertificate5th.pdf"; 
      this.spinnerService.showAll();
     // return this.http.get<PayStub[]>(`${this.url}/search`, {params})
      return this.httpClient.post(ruta,object, {responseType: 'blob' })
      .pipe( 
          map(res =>  { 
              this.spinnerService.hideAll();
              let bean = new Blob([res],{ type: 'application/pdf'});
              FileSaver.saveAs(bean, nameFile);
              return bean;
              }   ),
          catchError((err) => { 
              console.log("catchError : "  + catchError);
              this.spinnerService.hideAll();
              this.notificationService.serverErrorMessage(err.status +' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
              return new Observable<Blob>();
          })
              
          ) ;
      }

      searchToViewTable( paramsDeductionHold : ParamsDeductionHold): Observable<any> {
        this.spinnerService.showAll();
       const url = `${this.rutaServidor}${this.uri}search`; 
       return this.httpClient.post<any>(url, paramsDeductionHold  )
       .pipe(
         tap(response => {
           return response;
         }, 
          err =>{
           this.spinnerService.hideAll();
          this.notificationService.serverErrorMessage(err.status +' - '+ err.error.messages[0]);
           return new Observable<any>();
         },
          ()=>{
            this.spinnerService.hideAll();
          })
          ,
           catchError((err) => {
              return new Observable<Blob>();
          })
          
         ) ;
 } 
}



// WEBPACK FOOTER //
// ./src/app/core/services/deduction-hold.service.ts